import { Wifi } from 'lucide-react';

export const Logo = ({ size = 'default', showIcon = true, variant = 'default' }) => {
  const sizeClasses = {
    small: 'text-lg sm:text-xl',
    default: 'text-xl sm:text-2xl',
    large: 'text-2xl sm:text-4xl'
  };

  const iconSizes = {
    small: 20,
    default: 26,
    large: 36
  };

  const isLight = variant === 'light';

  return (
    <div className="flex items-center gap-2 sm:gap-3">
      {showIcon && (
        <div className="relative">
          {/* Outer glow ring */}
          <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-violet-500 to-cyan-500 blur-md opacity-60"></div>
          
          {/* Main icon container */}
          <div className={`
            relative w-9 h-9 sm:w-11 sm:h-11 
            bg-gradient-to-br from-violet-600 via-violet-500 to-cyan-500
            rounded-xl
            flex items-center justify-center
            shadow-lg
          `}>
            {/* Wi-Fi signal icon */}
            <Wifi 
              size={iconSizes[size]} 
              className="text-white drop-shadow-lg"
              strokeWidth={2.5}
            />
          </div>
        </div>
      )}
      <div className="flex flex-col leading-none">
        <span className={`font-extrabold tracking-tight ${sizeClasses[size]}`} style={{ fontFamily: 'Syne, sans-serif' }}>
          <span className={isLight ? 'text-white' : 'silver-text'}>MIGHTY</span>
          <span className="gradient-text">LINK</span>
        </span>
        <span className="text-[9px] sm:text-[10px] text-slate-500 tracking-[0.2em] uppercase mt-0.5">
          Field Services
        </span>
      </div>
    </div>
  );
};
